import normalizeEmailLib from 'validator/lib/normalizeEmail';

/**
 * Canonicalize emails before Firebase Auth calls.
 * Gmail/googlemail: strip dots, strip +tag, map googlemail → gmail.
 * Other providers: validator defaults (no Gmail-specific rewriting).
 */
export const normalizeEmail = (email: string): string => {
  const normalized = normalizeEmailLib(email.trim());
  return normalized || email.trim().toLowerCase();
};
